import React, { Component } from 'react';
import { FormErrors } from './FormErrors';
import {FormError} from './FormError';
import {loadCsrf} from './common/CsrfFetcher';
import Loader from 'react-loader';

class PasswordReset extends Component {

  constructor (props) {
    var hostApiUrl = process.env.REACT_APP_HOST_API_URL;

    super(props);
    this.state = {
      captchaImage: hostApiUrl + '/developer/mvc/captcha/image?v='+ Date.now(),
      email: '',
      lastName: '',
      captchaAnswer: '',
      formErrors: {email: '', lastName: '', captchaAnswer: '', genericFormLevelProblems: ''},
      emailValid: false,
      lastNameValid: false,
      captchaValid: false,
      formValid: false,
      showLoader: false
    }

    this.audioCaptcha = React.createRef();
    this.audioSrc = React.createRef();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.refreshCaptcha = this.refreshCaptcha.bind(this);
    this.handleIndividualValidation = this.handleIndividualValidation.bind(this);
    this.playClip = this.playClip.bind(this);

  }

  componentDidMount() {
    loadCsrf(this.setCsrfState);
  }

  setCsrfState = (csrfToken, csrfHeaderValue)=>{
    let state = this.state;
    state.csrfToken = csrfToken;
    this.csrfHeaderValue = csrfHeaderValue;
    this.setState({
      state
    });
  }

  refreshCaptcha() {
    this.setState({captchaImage: process.env.REACT_APP_HOST_API_URL + '/developer/mvc/captcha/image?v='+ Date.now()
                   });
  };

  playClip(){
    const audioElement = this.audioCaptcha.current;
  	audioElement.pause();
   	audioElement.load();
  	audioElement.play();
  };
  
  handleIndividualValidation = () =>{
      console.log('re runinng validations here');
      //rerun the validations to make the appropriate messages appear
      this.validateField('email', this.state.email);
      this.validateField('lastName', this.state.lastName);
      this.validateField('captchaAnswer', this.state.captchaAnswer);
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
                  () => { this.validateField(name, value) });
  }


  handleSubmit(event){
	event.preventDefault();
    
	console.log('A reset request was submitted: ' + this.state.lastName);
    this.handleIndividualValidation();

    //console.log(this.state.formValid);

    if(this.state.formValid) {

    	 this.setState({
             showLoader: true
         });

	    var resetPasswordData = {"loginOrEmail": this.state.email.trim(), "lastName" : this.state.lastName.trim()};
	
	    fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/resetPassword?captchaAnswer=" + this.state.captchaAnswer, {
	      headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
	        'X-CSRF-TOKEN': this.state.csrfToken
	      },
	      credentials: 'include',
	      method: 'POST',
	      body: JSON.stringify(resetPasswordData)
	    })
	    .then(response=> {
	      if (!response.ok) {
	        console.log("not ok " + response.statusText )
	        if(response.status === 400 || response.status === 404 ){
	          return response.json();
	        }
	        throw new Error("Unknown Problem occurred");
	      }
	      window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/resetpasswordconfirmation.jsp";
	    })
	    .then(json=>{
	    
	      let fieldValidationErrors = this.state.formErrors;

	      if(json != null) {

	    	this.refreshCaptcha();

	        console.log("json in new block is " + json.errorCode);
	        
	        if(json.errorCode === 'CaptchaInvalidException'){
	          fieldValidationErrors.captchaAnswer = "Captcha code does not match.";
	          fieldValidationErrors.genericFormLevelProblems="";
	        } else if (json.errorCode === 'UserDoesNotExistException'){
	          fieldValidationErrors.genericFormLevelProblems = ["Please enter a valid Email/Username and Last Name. If you experience problems resetting your password, please <a href=\"/support/password-help\">contact us</a>."];
	        } else {
	          fieldValidationErrors.genericFormLevelProblems = ["Error: Something went wrong, please try again."];
	        }
	      }
	      
	      this.setState({
              showLoader: false,
              formErrors: fieldValidationErrors
          });

	    }).catch(error => {
	        console.log("Uh oh.... didn't work " + error.message);
	        window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
	        return Promise.reject();
	    });
    }
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let state = this.state;
    
    switch(fieldName) {
      case 'email':
        let emailValid = value.trim().length >= 1 && value.trim().length <= 100;
        fieldValidationErrors.email = emailValid ? '' : 'Error: Please enter your E-Mail Address or Username.';
        state['emailValid'] = emailValid;
        break;
      case 'lastName':
        let lastNameValid = value.trim().length >= 1 && value.trim().length <= 100;
        fieldValidationErrors.lastName = lastNameValid ? '': 'Error: Please enter your Last Name.';
        state['lastNameValid'] = lastNameValid;
        break;
      case 'captchaAnswer':
       let captchaValid = (value.trim().length === 5);
       fieldValidationErrors.captchaAnswer = captchaValid ? '': 'Error: Please enter the text in the captcha image';
       state['captchaValid'] = captchaValid;
       break;
      default:
        break;
    }

    state['formValid'] = this.isFormValid();
    state['formErrors'] = fieldValidationErrors;
    this.setState({state});

    //console.log(this.state.emailValid +" --- " + this.state.lastNameValid + " --- " + this.state.captchaValid);
  }

  isFormValid() {
	//console.log(this.state.emailValid +" # " + this.state.lastNameValid + " # " + this.state.captchaValid);
	let result = (this.state.emailValid && this.state.lastNameValid && this.state.captchaValid);
    return result;
  }

  errorClass(error) {
    return(error.length === 0 ? 'has-success' : 'has-error');
  }


  render () {
    var audioUrl = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/captcha/audio?v="+Date.now();
    return (
      <div>
      	
      <form id="reset_password_form" name="reset_password_form" className="customForm" onSubmit={this.handleSubmit}>

        <FormErrors formErrors={this.state.formErrors.genericFormLevelProblems} />

        <div className={`form-group help-block ${this.errorClass(this.state.formErrors.email)}`}>
        
        { this.state.showLoader &&
            <Loader />
        }

          <label htmlFor="text_login_or_email">Email Address or Username</label>
          <FormError errorMessage={this.state.formErrors.email} />
          <input id="text_login_or_email" type="text" className="form-control" name="email"
            placeholder="Email or Username"
            value={this.state.email}
            onChange={this.handleUserInput}
            autoFocus="autoFfocus"
            maxLength="100"
            />
        </div>

        <div className={`form-group help-block ${this.errorClass(this.state.formErrors.lastName)}`}>

          <label htmlFor="lastName">Last Name</label>
          <FormError errorMessage={this.state.formErrors.lastName} />
          <input id="lastName" type="lastName" className="form-control" name="lastName"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleUserInput}
            maxLength="100"
            />
        </div>

        <div className={`form-group help-block ${this.errorClass(this.state.formErrors.captchaAnswer)}`}>
            <div id="captcha" className="framePanel captchaBgColor">
                <span><img id="captchaImage" src={this.state.captchaImage} alt="captcha" tabIndex="0"/></span>
                <a id="captchaRefresh" role="link" onClick={this.refreshCaptcha} aria-label="Click on Refresh Button to get New Captcha"><i className="fas fa-sync-alt"></i></a>
                <a id="captchaAudio" role="link" onClick={this.playClip} aria-label="Click on Audio Button to get Captcha"><i className="fa fa-headphones"></i></a>
            </div>
            <audio id="audioCaptcha" ref={this.audioCaptcha} >
                <source id="audioSrc" ref={this.audioSrc} src={audioUrl} type="audio/wav" />
            </audio>
      </div>
      <div className={`form-group help-block ${this.errorClass(this.state.formErrors.captchaAnswer)}`}>
          <label htmlFor="text_captcha">Enter text seen in above image here</label>
          <FormError errorMessage={this.state.formErrors.captchaAnswer} />
          <input id="text_captcha" name="captchaAnswer" type="captchaAnswer" className="form-control"
          value={this.state.captchaAnswer}
          onChange={this.handleUserInput}
          maxLength="100"
          />
      </div>

      <button type="submit" id="resetPassButton" className="btn btn-primary variableWidth" disabled={this.state.showLoader} >Reset Password</button>
      </form>
      </div>
    )
  }
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/PasswordReset.js